<section class="main">
    <div class="sections">
        <section class="top">
            <img src="./../../../../assets/svg/Group 33.svg" alt="">
        </section>
        <section class="footer">
            <h1>Mantenimiento</h1>
            <p>Esta página se encuentra<br> en mantenimiento o no existe, volveremos pronto.</p>
            <a class="botonInicio" mat-raised-button href="index.html" >Volver a inicio</a>
        </section>
    </div>
</section>